import { Schema, NodeSpec, MarkSpec } from 'prosemirror-model';

const nodes: NodeSpec = {
   doc: {
      content: 'block+',
   },

   paragraph: {
      content: 'inline*',
      marks: '_',
      group: 'block quoteless',
      parseDOM: [{ tag: 'p' }],
      toDOM() {
         return ['p', 0];
      },
   },

   text: {
      group: 'inline',
      toDOM(node: any) {
         return node.text;
      },
   },

   hard_break: {
      inline: true,
      group: 'inline',
      selectable: false,
      parseDOM: [{ tag: 'br' }],
      toDOM() {
         return ['br'];
      },
   },

   // Wikis only support headings with levels 2-6.
   heading: {
      attrs: { level: { default: 1 } },
      content: 'text*',
      marks: '_',
      group: 'block quoteless',
      parseDOM: [
         { tag: 'h2', attrs: { level: 2 } },
         { tag: 'h3', attrs: { level: 3 } },
         { tag: 'h4', attrs: { level: 4 } },
         { tag: 'h5', attrs: { level: 5 } },
         { tag: 'h6', attrs: { level: 6 } },
      ],
      toDOM(node: any) {
         return ['h' + node.attrs.level, 0];
      },
   },

   code_block: {
      content: 'text*',
      group: 'block quoteless',
      code: true,
      parseDOM: [{ tag: 'pre', preserveWhitespace: true }],
      toDOM() {
         return ['pre', ['code', 0]];
      },
   },

   blockquote: {
      attrs: {
         format: { default: 'long' },
         attribute: { default: null },
      },
      content: 'quoteless+',
      group: 'block',
      parseDOM: [{ tag: 'blockquote' }],
      toDOM() {
         return ['blockquote', 0];
      },
   },

   image: {
      inline: true,
      attrs: {
         imageid: {},
         src: {},
         size: { default: 'standard' },
         align: { default: 'left' },
      },
      group: 'inline',
      toDOM(node: any) {
         return ['img', node.attrs];
      },
   },
};

const marks: MarkSpec = {
   em: {
      parseDOM: [
         { tag: 'i' },
         { tag: 'em' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { style: 'font-style', getAttrs: (value: any) => value == 'italic' && null },
      ],
      toDOM() {
         return ['em'];
      },
   },

   strong: {
      parseDOM: [
         { tag: 'strong' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { tag: 'b', getAttrs: (node: any) => node.style.fontWeight != 'normal' && null },
         {
            style: 'font-weight',
            // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
            getAttrs: (value: any) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
         },
      ],
      toDOM() {
         return ['strong'];
      },
   },

   underline: {
      parseDOM: [
         { tag: 'u' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { style: 'text-decoration', getAttrs: (value: any) => value == 'underline' && null },
      ],
      toDOM() {
         return ['u'];
      },
   },

   subscript: {
      parseDOM: [{ tag: 'sub' }],
      toDOM() {
         return ['sub'];
      },
   },

   superscript: {
      parseDOM: [{ tag: 'sup' }],
      toDOM() {
         return ['sup'];
      },
   },

   code: {
      parseDOM: [{ tag: 'tt' }],
      toDOM() {
         return ['tt'];
      },
   },

   strikethrough: {
      parseDOM: [
         { tag: 'strike' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { style: 'text-decoration', getAttrs: (value: any) => value == 'line-through' && null },
      ],
      toDOM() {
         return ['strike'];
      },
   },
   link: {
      attrs: {
         href: {},
         title: { default: null },
         target: { default: null },
      },
      inclusive: false,
      parseDOM: [
         {
            tag: 'a[href]',
            getAttrs(dom: any) {
               return {
                  href: dom.getAttribute('href'),
                  title: dom.getAttribute('title'),
                  target: dom.getAttribute('target'),
               };
            },
         },
      ],
      toDOM(node: any) {
         return ['a', node.attrs];
      },
   },
};

const schema = new Schema({ nodes, marks });

export default {
   nodes,
   marks,
   schema,
};
